import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { Business, BusinessService } from './services/business.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  showFooter = true;
  private routeSub: Subscription | null = null;

  constructor(
    private router: Router,
    private businessService: BusinessService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.routeSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Existing footer visibility logic
        this.showFooter = !(event.url === '/not-found' || event.url.includes('/not-found'));

        // Favicon logic
        const url = event.urlAfterRedirects;
        const businessIdMatch = url.match(/^\/(\d+)/);
        if (businessIdMatch) {
          const businessId = parseInt(businessIdMatch[1], 10);
          this.loadBusinessFavicon(businessId);
        } else {
          this.setDefaultFavicon();
        }
      }
    });
  }

  private loadBusinessFavicon(businessId: number) {
    this.businessService.getLandingPage(businessId).subscribe({
      next: (business: Business) => {
        const faviconUrl = business.favicon
          ? `${environment.baseUrl}${business.favicon}`
          : 'assets/favicon.ico';
        this.setFavicon(faviconUrl);
      },
      error: () => {
        this.setDefaultFavicon();
      }
    });
  }

  private setDefaultFavicon() {
    this.setFavicon('assets/favicon.ico');
  }

  private setFavicon(url: string) {
    let link: HTMLLinkElement | null = this.document.querySelector("link[rel~='icon']");
    if (!link) {
      link = this.document.createElement('link');
      link.rel = 'icon';
      this.document.head.appendChild(link);
    }
    link.href = url;
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}